// extracted by mini-css-extract-plugin
export var col_1 = "footer-module--col_1--rsemT";
export var col_2 = "footer-module--col_2--1g7ZA";
export var col_3 = "footer-module--col_3---VM0J";
export var footer = "footer-module--footer--NHcXd";
export var footer__nav = "footer-module--footer__nav--DqSEH";
export var footer__social_image = "footer-module--footer__social_image--C45QP";
export var footer__socials = "footer-module--footer__socials--TvjeD";
export var footer_module__bottom = "footer-module--footer_module__bottom--xx8vN";
export var footer_module__top = "footer-module--footer_module__top--+lz4H";
export var social__icons = "footer-module--social__icons--AQJQa";